module.exports = __webpack_public_path__ + "media/images/episode5-e5f84b7c07c77124953f5d57dc36c06d.jpeg";